import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box } from "@mui/material";
import Hosted from "./hosted";
import Applications from "./applications";
import Liked from "./liked";
import { useTheme } from "../../../../context/themeContext";
import useManageProjects from "../../../../hooks/useManageProjects";
import { useSelector } from "react-redux";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: "1rem 1.5rem" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
  const { theme, darkMode } = useTheme();
  const user = useSelector((state) => state.user.value);
  const { fetchProjects, fetchLikedProjects, fetchApplications } =
    useManageProjects();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchProjects(user);
    fetchLikedProjects(user);
    fetchApplications();
  }, [user]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTab-root": {
              "&.Mui-selected": {
                color: darkMode && theme.palette.darkgrey.darkgreybody50,
              },
            },
          }}
        >
          <Tab
            label="Hosted"
            {...a11yProps(0)}
            sx={{
              textTransform: "capitalize",
            }}
          />
          <Tab
            label="Applications"
            {...a11yProps(1)}
            sx={{
              textTransform: "capitalize",
            }}
          />
          <Tab
            label="Liked"
            {...a11yProps(1)}
            sx={{
              textTransform: "capitalize",
            }}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Hosted />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Applications />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Liked />
      </CustomTabPanel>
    </Box>
  );
}
